export * from './kunde-entfernt.interface';
